import React, { useContext, Link } from "react"
import { LanguageContext } from "../../context"
import Block from "./block"
import SocialMedia from "../social-media"
import logo from  "../../assets/images/logo-white.png"
import { useStaticQuery, graphql, navigate } from "gatsby"
import Webform from '../../../plugins/gatsby-drupal-webform-unida'
import Menu from "../menu"
import { useBreakpoint } from "gatsby-plugin-breakpoints"
import socialList from "../social-media/social-media-list"

 const Footer = () => {
   const { t } = useContext(LanguageContext)
   const breakpoints = useBreakpoint()
   const data = useStaticQuery(graphql`
      query FooterQuery {
        form: webformWebform(drupal_internal__id: {eq: "newsletter_goel"}) {
          drupal_internal__id
          langcode
          elements {
            name
            type
            attributes {
              name
              value
            }
          }
        }
      }
    `)

  const form = data?.form

   const socialList2 =
     [
       {
       "key" : 1,
       "icon" : "icons-32-x-32-export-twitter",
       "url" : "https://twitter.com/fundaciogoel",
       "title": "Twitter",
       "iconClassName": "no-fill"
      },
     {
       "key" : 2,
       "icon" : "icons-32-x-32-export-facebook",
       "url" : "https://facebook.com/goel.fundacio",
       "title": "Facebook",
       "iconClassName": "no-fill"
     },
     {
       "key" : 3,
       "icon" : "icons-32-x-32-export-instagram",
       "url" : "https://instagram.com/fundaciogoel",
       "title": "Instagram",
       "iconClassName": "no-fill"
     }
   ]


   return (
    <footer className="bg-orange p-37-56-27  white">
    <div className="row m-b-113">
        <Block
          logo={logo}
          address={t("Avinguda de Béjar 299, 08226 Terrassa")}
          phone={t("Telf. (+34) 93 780 76 14")}
          schedule={t(`Dill-Div: 9.00h - 15.00h  Diumenges: 10h - 13:30h`)}
          pos={1}
          className={`${breakpoints.xs ? 'col-8 m-b-24' : ''} ${breakpoints.md ? 'col-md-4' : 'col-md-2'} normal-light-l`}
          key={1}
         />
         <div className={`${breakpoints.md ? 'col-md-1' : 'col-md-1'}`}></div>
         <Block
            pos={2}
            key={2}
            className={`${breakpoints.xs ? 'col-6' : ''} ${breakpoints.md ? 'col-md-3' : 'col-md-2'} Normal-Medium-L---white`}
          >
          <Menu menuName="footer-goel" key="footer-goel" />
          </Block>
          {
            /*
          <Block
             pos={3}
             className={`${breakpoints.xs ? 'col-6 m-b-24' : ''} ${breakpoints.md ? 'col-md-3 medium-m-b-72' : 'col-md-2'} Normal-Medium-L---white`}
           >
            <Menu menuName="footer-2" />
           </Block> */
         }
        <div className={`${breakpoints.md ? 'col-md-5' : 'col-md-1'}`}>
        </div>
        <div className={`${breakpoints.md ? 'col-md-7' : 'col-md-4 offset-md-2'}  newsletter small-m-t-40 medium-m-t-40`}>
              <div className="nl-title">{t("Newsletter")}</div>
              <div className="nl-description Normal-Medium-L---white">{t("Subscriu-te a la nostra newsletter i no perdis res sobre les nostres activitats, esdeveniments, etc.!")}</div>
              <SubscribeForm data={form} />
              {/*<span>form here</span>*/}
        </div>
    </div>

    {breakpoints.xs  &&
      <div className="col-md-12 col-12 p-b-56 m-b-56 small-social-media-wrapper">
        <SocialMedia
          socialList={socialList}
        />
      </div>
    }

    {breakpoints.md  &&
      <div className="row">
        <div className="col-md-3">
        </div>
        <div className="col-md-8 Normal-Light-L---white align-center m-b-60 medium-copyright-notice">
          Fundacio Privada Goel  © {new Date().getFullYear()} {/*t('built')*/}
        </div>
        <div className="col-md-2">
        </div>
      </div>
    }

    <div className="row copyright-notice">
        <div className={`${breakpoints.md ? 'col-md-6' : 'col-md-4'} legal Normal-Medium-L---white`}>
            <Menu menuName="goel-footer-legal" key="goel-footer-legal" />
            {/*
            <ul>
              <li><a href="/">{t("Política de Cookies")}</a></li>
              <li><a href="/avis-legal-i-de-privacitat">{t("Avís Legal i de Privacitat")}</a></li>
            </ul> */}
        </div>

          <div className="col-md-1">
          </div>


        <div className="col-md-4 Normal-Light-L---white copyright-notice">
                Fundació Privada Goel  © {new Date().getFullYear()} {/*t('built')*/}
        </div>
        <div className={`${breakpoints.md ? 'col-md-5' : 'col-md-3'} medium-social-media-wrapper`}>
          <SocialMedia
            socialList={socialList}
          />
        </div>
    </div>
</footer>
   )
 }

 const SubscribeForm = ({ data }) => {
 return(
   	<Webform
   		webform={data}
   		endpoint={`${process.env.GATSBY_DRUPAL_API_URL}/react_webform_backend/submit`} // "http://localhost:8888/react_webform_backend/submit"
   		onSuccess={(response) => navigate(response.settings.confirmation_url)}
      buttonAsIcon
   	/>
 )
 }

 export default Footer
